import api from "@/axios";
import type { Roll } from "@/types/roll-types";
import type {BatchRoll} from "@/types/batch-types";

export const getRollsList = async (): Promise<any> => {
    const response = await api.get('/rolls');
    return response.data;
}

export const getRollById = async (id: string): Promise<any> => {
    const response = await api.get(`/rolls/${id}`);
    return response.data;
}

export const getHighestRollNumber = async (): Promise<number> => {
    const response = await api.get<number>('/rolls/highest-roll-number');
    return response.data;
}

export const updateRoll = async (rollData: Roll, rollId: string) => {
  const response = await api.patch(`/rolls/${rollId}`, rollData)
  return response.data
}

export const sendRollsToSupplier = async (data: any) => {
    const response = await api.post('/rolls/send-to-supplier', data)
    return response.data
}

export const getRollsByPreviousBatchId = async (previousBatchId: string): Promise<BatchRoll[]> => {
    const response = await api.get(`/rolls/previous-batch/${previousBatchId}`)
    return response.data
}